import React, { useCallback, useEffect } from 'react';
import { initMetaPixelWhenIdle, trackPixelEvent } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PriceSection } from './components/PriceSection';
import { TramosSection } from './components/TramosSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
const MEGAPACK_CHECKOUT_URL = 'https://tufenixdigital.store/cart/53889590722924:1';
export function App() {
  useEffect(() => {
    initMetaPixelWhenIdle();
  }, []);
  const handleCheckout = useCallback((url: string) => {
    trackPixelEvent('InitiateCheckout', {
      content_type: 'product',
      currency: 'UYU'
    });
    window.location.assign(url);
  }, []);
  return <div className="min-h-full w-full bg-white font-sans text-ink" data-id="element-0" data-mp="23utcq6luo6cd">
      <Hero data-id="element-1" data-mp="3ikqzm1my986s" />
      <main data-id="element-2" data-mp="3iiwfuqnezm4a">
        <PainSection data-id="element-3" data-mp="3ijfx0558q6h9" />
        <BenefitsSection data-id="element-4" data-mp="3ihv0i9zd8dgr" />
        <PriceSection onBuy={() => handleCheckout(MEGAPACK_CHECKOUT_URL)} data-id="element-5" data-mp="3mlavz2zp87rv" />
        <TramosSection onBuy={handleCheckout} data-id="element-6" data-mp="3mj6ibtbzzuee" />
        <TestimonialsSection data-id="element-7" data-mp="3rbzpsoyupgu6" />
        <FaqSection data-id="element-8" data-mp="3rd1azm9kzjpm" />
      </main>
      <Footer data-id="element-9" data-mp="5yhupa6n3cr" />
    </div>;
}